<template>
  <vuestic-widget header-text="Consolidado Por Periodo">
    <select-periodo @sendFiltros="getDataFromPeriodo"/>
    <tabla-periodo-consolidado :datos="datos"/>
  </vuestic-widget>
</template>

<script>
  import VuesticWidget from "../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget";
  import SelectPeriodo from "../Components/selectPeriodo";
  import TablaPeriodoConsolidado from "../Components/tablaPeriodoConsolidado";

  export default {
    name: "consolidadoPeriodo",
    components: {TablaPeriodoConsolidado, SelectPeriodo, VuesticWidget},
    data() {
      return {
        datos: []
      }
    },
    methods: {
      getDataFromPeriodo(event) {
        this.$axios.get("/finanzas/consolidado-ventas" + event)
          .then(({data}) => this.datos = this.reduce(data.items))
          .catch(error => console.error(error))
      },
      reduce(data) {
        return data.reduce((acc, current) => {
          const ocurrence = acc.find(item => item.sucursal_id === current.sucursal_id);
          if (!ocurrence) {
            return acc.concat([current]);
          } else {
            const {venta_actual, venta_anio_anterior} = ocurrence
            current.venta_actual += venta_actual
            current.venta_anio_anterior += venta_anio_anterior
            return [...acc.filter(item => item.sucursal_id !== current.sucursal_id), current];
          }
        }, []);
      }
    },
    created() {
      this.$store.dispatch("loadSucursal")
    }
  }
</script>

<style scoped>

</style>
